import React, { Fragment, useState } from 'react'
import { Col, Card, CardBody, Button, Table, Row } from 'reactstrap';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileImage, faFile } from "@fortawesome/free-solid-svg-icons";
import { Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PDFTranscription from '../../../../../AudioPanel/PDFTranscription';
import PrintsProceduresPDF from '../PrintsProceduresPDF';



const ResultProcedures = ({ procedure }) => {
    const [showPDf, setShowPDf] = useState(false);
    const [showAttachedFileProcedure, setShowAttachedFileProcedure] = useState(false);
    const perfil = JSON.parse(sessionStorage.getItem('clinica'));

    //una transcipcion para varios audios
    const printTranscription = async () => {
        setShowPDf(true);
        console.log('procedure', procedure)
        let id_admision = parseInt(procedure.id_admision);
        await fetch(process.env.REACT_APP_PUBLIC_URL + `admision-transcripcion/consultar-impresion?id_admision=${id_admision}&id_transcripcion=${procedure.id_transcripcion}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response =>
            response.json()
        ).then(data => {
            console.log("RESPONSE", data);
            let dataQuery = data.info;
            let genderDoctor = dataQuery.sexo_doctor;
            let prefixDoctor = 'Dr. ';
            switch (genderDoctor) {
                case 'Masculino':
                    prefixDoctor = 'Dr. ';
                    break;
                case 'Femenino':
                    prefixDoctor = 'Dra. ';
                    break;
            }
            let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
            let firmDoctor = process.env.REACT_APP_PUBLIC_URL + dataQuery.url_firma_doctor + '/' + sessionStorage.getItem('token');
            let firmDoctorSupport = process.env.REACT_APP_PUBLIC_URL + dataQuery?.medico_apoyo?.url_firma_doctor_alter + '/' + sessionStorage.getItem('token');

            console.log("dataQuery", dataQuery.servicio.servicios[0]);

            let nameService = dataQuery.servicio.servicios[0].nombre;
            let codigoService = dataQuery.servicio.servicios[0].codigo;

            const dataPrint = {
                today: new Date(),
                fullname: dataQuery.fullname,
                documentNumber: dataQuery.num_documento,
                typeDocument: dataQuery.tip_documento,
                profile: perfil,
                birthday: moment(dataQuery.fec_nacimiento).format('YYYY-MM-DD'),
                age: dataQuery.edad,
                gender: dataQuery.sexo,
                address: dataQuery.direccion.direccion,
                city: dataQuery.direccion.ciudad,
                telephone: dataQuery.telefono1,
                nitThird: dataQuery.nit_tercero,
                nameThird: dataQuery.nombre_tercero,
                regime: dataQuery.regimen_paciente,
                urlLogo: sessionStorage.getItem('logoURL'),
                transcription: dataQuery.transcripcion,
                nameDoctor: nameDoctor,
                specialtyDoctor: dataQuery.especialidad_doctor,
                medicalRegister: dataQuery.reg_medico,
                urlDoctorFirm: firmDoctor,
                nameService: nameService,
                codigoService: codigoService,
                id_admision: id_admision,
                fecha_admision: dataQuery.fecha_admision,
                celular: dataQuery.celular,
                printInnerWindow: true,
                suportDoc: dataQuery.medico_apoyo || null,
                firmDoctorSupport
            };
            PDFTranscription(dataPrint);
        }).catch(error => {
            console.log(error);
        });
    }

    const printResultsProcedurtes = (id_admision, type) => {
        setShowPDf(true);
        PrintsProceduresPDF.printPDF(parseInt(id_admision), type, true);
    }

    const onToggleToShowFile = (file_location) => {
        //setShowPDf(true);
        window.open(procedure.url_file, '_blank');
        //document.getElementById('file-procedure').src = file_location;
    }

    return (
        <Fragment>
            <div style={{ border: '1px solid #4ce1b6', borderRadius: 5, padding: '1em', width: '100%', marginBottom: '1em' }}>
                <Row>
                    <Col md={12}>
                        {/* <div style={{ whiteSpace: 'pre-line' }}>{procedure.conclution_result}</div> */}
                        <div style={{ overflow: 'auto' }}>
                            <div dangerouslySetInnerHTML={{ __html: procedure.conclution_result }} style={{ margin: 0, padding: 0 }} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', margin: '0.5em 0em' }}>
                        {!!procedure.url_file &&
                            <div>
                                <Tooltip title="Ver archivo Adjunto">
                                    <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1.5em', height: '1.5em', marginRight: '0.25em' }}
                                        //disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                        onClick={() => {
                                            onToggleToShowFile(procedure.url_file);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faFileImage} style={{ color: '#153365', width: '1em', height: '1em' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                        <div>
                            <Tooltip title="Imprimir Resultado">
                                <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1.5em', height: '1.5em', marginRight: '0.25em' }}
                                    //disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                    onClick={() => {
                                        if (procedure.type === 'gamagrafia') {
                                            printTranscription();
                                        } else {
                                            printResultsProcedurtes(procedure.id_admision, procedure.type);
                                        }
                                    }}
                                >
                                    {/* <ListAltIcon style={{ color: '#153365', width: '1em', height: '1em' }} /> */}
                                    <FontAwesomeIcon icon={faFilePdf} style={{ color: '#153365', width: '1em', height: '1em' }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </Row>
            </div>
            {showPDf ?
                <Modal
                    open={showPDf}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%' }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDf(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
              {showAttachedFileProcedure ?
                <Modal
                    open={showPDf}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%' }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowAttachedFileProcedure(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="file-procedure"  /* src={procedure.url_file} */>
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default ResultProcedures